<span [ngSwitch]="status">
    <span class="badge badge-warning" *ngSwitchCase="'PENDING'">{{'transferItemStatusValue.PENDING' | translate}}</span>
    <span class="badge badge-primary" *ngSwitchCase="'PARTIAL'">{{'transferItemStatusValue.PARTIAL' | translate}}</span>
    <span class="badge badge-success" *ngSwitchCase="'DELIVERED'">{{'transferItemStatusValue.DELIVERED' | translate}}</span>
    <span class="badge badge-danger" *ngSwitchCase="'CANCELLED'">{{'transferItemStatusValue.CANCELLED' | translate}}</span>
    <span class="badge badge-info" *ngSwitchDefault>{{'transferItemStatusValue.' + status | translate}}</span>
</span>